const getListingQualityRuleDefinitions = /* GraphQL */ `
  query GetListingQualityRuleDefinitions {
    listingQualityRuleDefinitions {
      ruleId
      displayName
      category
    }
  }
`

export default getListingQualityRuleDefinitions
